var _circle, _circle2, _rect, _circle3, _circle4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 115,
    viewBox: "0 0 73 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9588,
    cy: 101.48,
    r: 11.9698,
    transform: "rotate(-6.5 22.9588 101.48)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2478,
    cy: 16.2478,
    r: 11.9698,
    transform: "rotate(-6.5 13.2478 16.2478)",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1523,
    y: 15.4826,
    width: 3.98992,
    height: 85.7834,
    rx: 1.99496,
    transform: "rotate(-6.5 11.1523 15.4826)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.99496
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9588,
    cy: 98.4797,
    r: 11.9698,
    transform: "rotate(-6.5 58.9588 98.4797)",
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.2478,
    cy: 13.2478,
    r: 11.9698,
    transform: "rotate(-6.5 49.2478 13.2478)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.1523,
    y: 12.4826,
    width: 3.98992,
    height: 85.7834,
    rx: 1.99496,
    transform: "rotate(-6.5 47.1523 12.4826)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.99496
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanger);
export default __webpack_public_path__ + "static/media/hanger.a792358fc295344c667866e706a24cf4.svg";
export { ForwardRef as ReactComponent };